import React, { useEffect, useState } from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import axios from 'axios';

function Institution() {
    const [careerData, setCareerData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchSponsors = async () => {
            try {
                const response = await axios.get('https://admin.k12pulse.com/api/sponsor');
                setCareerData(response.data.data);
                localStorage.setItem('sponsorData', JSON.stringify(response.data.data));
                localStorage.setItem('sponsorDataTimestamp', new Date().toISOString());
            } catch (err) {
                setError('Veri alınırken bir hata oluştu.');
            } finally {
                setLoading(false);
            }
        };

        const storedData = localStorage.getItem('sponsorData');
        const storedTimestamp = localStorage.getItem('sponsorDataTimestamp');

        const now = new Date();
        const lastFetch = storedTimestamp ? new Date(storedTimestamp) : null;
        const secondsSinceLastFetch = lastFetch ? (now - lastFetch) / 1000 : Infinity;

        if (storedData && secondsSinceLastFetch < 30) {
            setCareerData(JSON.parse(storedData));
            setLoading(false);
        } else {
            fetchSponsors();
        }
    }, []);

    return (
        <div className='hero page-wrapper'>
            <section className='hero'>
                <Container>
                    <Row className="justify-content-center">
                        <Col md={10} lg={10}>
                            <h4 className='mb-3 text-uppercase breadcrumb-text'>ANASAYFA / KURUMLAR -</h4>
                            <h2 className='mb-3 text-uppercase'>KURUMLAR</h2>
                            <div className='institution-wrapper'>
                                <div className="brand-items-wrapper d-flex flex-wrap">
                                    {careerData.map((careerItem, i) => (
                                        <div className='brand-items' key={i}>
                                            <img
                                                src={careerItem.image}
                                                className="sponsor-image"
                                                alt="Brand"
                                            />
                                            <span>{careerItem.title}</span>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
        </div>
    );
}

export default Institution;
